export const checkAllExist = (arr1, arr2) => {
	let allExist = false;
	for (let obj1 of arr1) {
		const match = arr2.some(
			obj2 => obj2.name === obj1.name && obj2.parent === obj1.parent
		);
		if (!match) {
			return false; // Return false if any matching object is not found
		} else {
			allExist = true;
		}
	}
	return allExist; // Return true if all matching objects are found
};
